import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SetupTourGuideFormPageRoutingModule } from './setup-tour-guide-form-routing.module';

import { SetupTourGuideFormPage } from './setup-tour-guide-form.page';
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SetupTourGuideFormPageRoutingModule,
    ReactiveFormsModule,
    IonicSelectableModule
  ],
  declarations: [SetupTourGuideFormPage]
})
export class SetupTourGuideFormPageModule {}
